/* eslint-disable sort-keys */
import { Clickable, P } from '@ahmdigital/ui';

import Alert from './alert';
import CodeOfPractice from './code-of-practice';
import constants from '../../../../ahm-constants';
import ContactUs from './contact-us';
import FAQ from './faq';
import FormsAndGuides from './forms-and-guides';
import SupportSection from './support-section';

const lifeAndIncomeContent = {
  meta: {
    title: 'Life insurance',
    description: 'Need help? Get in touch with us about ahm life insurance.',
  },
  banner: {
    title: 'Help & Support',
    preHeading: 'ahm Life and Life Express Insurance purchased on or before 30 June 2023',
  },
  nav: [
    {
      name: 'Contact us',
      url: '#contactUs',
    },
    {
      name: 'Make a claim',
      url: '#makeAClaim',
    },
    {
      name: 'Life Insurance Code of Practice',
      url: '#codeOfPractice',
    },
    {
      name: 'Policies',
      url: '#policies',
    },
    {
      name: 'Forms and guides',
      url: '#formsAndGuides',
    },
    {
      name: 'FAQs',
      url: '#faqs',
    },
  ],
  alert: <Alert />,
  body: (
    <>
      <ContactUs />
      <FormsAndGuides />
      <SupportSection />
      <CodeOfPractice />
      <FAQ />
    </>
  ),
  thingsYouShouldKnow: (
    <>
      <P>Read this bit to understand more about our life insurance products, and who we partner with.</P>
      <P>
        Any advice provided is general only and doesn’t consider your objectives, financial situation or needs. You
        should carefully read the relevant <Clickable to="#formsAndGuides">Product Disclosure Statement</Clickable>{' '}
        (which sets out the product terms, conditions and exclusions),{' '}
        <Clickable to="#formsAndGuides">Target Market Determination</Clickable> and{' '}
        <Clickable to="#formsAndGuides">Financial Services Guide</Clickable> available on this page or by contacting us
        to ensure the product is right for you.
      </P>
      <P>
        ahm life insurance products are issued by the insurer, Hannover Life Re of Australasia Ltd ABN 37 062 395 484,
        AFSL 530811 (Hannover). ahm life insurance products are administered by Greenstone Financial Services Pty Ltd
        ABN 53 128 692 884, AFSL 343079 (Greenstone). ahm health insurance, a business of Medibank Private Limited ABN
        47 080 890 259, AR 286089 (Medibank Private) promoted the insurance products as an authorised representative
        (AR) of Greenstone, AR 286089.
      </P>
      <P>
        Your personal information will be handled in accordance with Privacy Policies of the parties involved. Click
        here for{' '}
        <Clickable to={constants.URLS.THIRD_PARTY.HANNOVER_RE_PRIVACY_POLICY}>Hannover’s Privacy Policy</Clickable> and{' '}
        <Clickable to={constants.URLS.THIRD_PARTY.GREENSTONE_PRIVACY_POLICY}>Greenstone’s Privacy Policy</Clickable>.
      </P>
    </>
  ),
};

export default lifeAndIncomeContent;
